import React from 'react'
import LoadingBodyView from './view'

const LoadingBody = ({ ...props }) => <LoadingBodyView {...props} />

export default LoadingBody
